<h2 mat-dialog-title>Add Pool Point Client</h2>
<mat-dialog-content>
    <form [formGroup]="clientForm" (ngSubmit)="submit()">
        <mat-form-field>
            <mat-label>Pool Point Client Name</mat-label>
            <input matInput formControlName="pool_point_client_name">
        </mat-form-field>
        <app-contact-autocomplete
            placeholder="Search contacts..." 
            [type]="'customer_contact_list'" 
            [formControl]="poolPointClientContactControl" 
            (selected)="onClientSelected($event)"
        ></app-contact-autocomplete>
    </form>
</mat-dialog-content>
<mat-action-list>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-raised-button (click)="submit()" color="primary">Submit</button>
</mat-action-list>